var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50.5,
    r: 49.5089,
    stroke: "#091E42",
    strokeOpacity: 0.14,
    strokeWidth: 0.982273
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_5610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4154 40.5992C46.4154 38.4211 48.2311 37.582 51.142 37.582C55.3811 37.582 60.7607 38.8805 64.9998 41.1664V28.0523C60.3811 26.207 55.7717 25.5039 51.1514 25.5039C39.8529 25.5039 32.3232 31.4023 32.3232 41.2648C32.3232 56.6852 53.4951 54.1852 53.4951 60.8352C53.4951 63.4133 51.2592 64.243 48.1529 64.243C43.5436 64.243 37.5857 62.3383 32.9092 59.7992V72.3477C37.7205 74.4236 42.9035 75.5001 48.1436 75.5117C59.7264 75.5117 67.7045 70.5305 67.7045 60.5117C67.7045 43.8914 46.4154 46.8695 46.4154 40.5992Z",
    fill: "#635BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_5610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(25 25.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.afe50df945f9ce8ae0575040dd892d11.svg";
export { ForwardRef as ReactComponent };